export { default as BookmarkOutlineIcon } from '~icons/mdi/bookmark-outline';
